/** @format */
import { Pipe, PipeTransform } from '@angular/core';
import { Code } from 'common-typescript/types';
import { LocaleService } from 'sis-common';
import { CommonCodeService } from '../service/common-code.service';

@Pipe({
    name: 'codeLocalizedName',
    standalone: false,
})
export class CodeLocalizedNamePipe implements PipeTransform {
    constructor(
        private commonCodeService: CommonCodeService,
        private localeService: LocaleService,
    ) {}

    transform(urn: string): Promise<string> {
        if (!urn) {
            return Promise.resolve(undefined);
        }
        return this.commonCodeService.getCode(urn).then((code: Code) => this.localeService.localize(code?.name));
    }
}
